function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = 'expires='+ d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

document.addEventListener('DOMContentLoaded', async () => {
  const ageGateAcceptBtn = document.querySelector<HTMLElement>('.js-age-gate-yes');
  const ageGateAcceptDecline = document.querySelector<HTMLElement>('.js-age-gate-no');
  const errorMsg = document.querySelector<HTMLElement>('.js-age-gate-error');

  if (ageGateAcceptBtn && ageGateAcceptDecline) {
    ageGateAcceptBtn.addEventListener('click', function() {
      setCookie('muskoka-contest-age-gate', 'yes', 30);
      errorMsg?.classList.remove('show');
      errorMsg?.setAttribute('aria-hidden', 'true');
      location.reload();
    });

    ageGateAcceptDecline.addEventListener('click', function() {
      errorMsg?.classList.add('show');
      errorMsg?.setAttribute('aria-hidden', 'false');
    });
  }
});
